document.addEventListener("DOMContentLoaded", function () {
	// logo carousel slider
	var slider = document.querySelector("#homepage-logo-carousel-wrapper");

	if (slider) {
		var slider = tns({
			container: slider,
			items: 2,
			autoplay: true,
			controls: false,
			nav: true,
			navPosition: "button",
			autoplayButtonOutput: false,
			autoplayTimeout: 1500,
			responsive: {
				500: {
					edgePadding: 20,
					gutter: 20,
					items: 4,
				},
			},
		});
	}

	// add to cart button
	var addToCartButtons = document.querySelectorAll(
		".custom-add-to-card-button"
	);

	if (addToCartButtons.length > 0) {
		function reloadCart() {
			fetch(`${window.theme.routes.cart}.js`)
				.then((response) => response.json())
				.then((response) => {
					console.log(response);
					document.dispatchEvent(
						new CustomEvent("theme:cart:change", {
							detail: {
								cart: response,
							},
							bubbles: true,
						})
					);
				});
		}

		function handleCustomATCButtonClick(evt) {
			evt.preventDefault();

			var postData = {
				items: [
					{
						form_type: "product",
						utf8: "✓",
						id: +this.dataset.id,
						quantity: 1,
					},
				],
			};

			fetch(`${window.theme.routes.cart}/add.js`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(postData),
			})
				.then((response) => response.json())
				.then((data) => {
					reloadCart();
					var popdown = document.querySelector(
						"[data-product-add-popdown-wrapper]"
					);
					popdown.dispatchEvent(
						new CustomEvent("theme:cart:popdown", {
							detail: {
								variant: data.items[0],
							},
							bubbles: true,
						})
					);
				});
		}

		addToCartButtons.forEach(function (btn) {
			btn.addEventListener("touchstart", handleCustomATCButtonClick);
			btn.addEventListener("click", handleCustomATCButtonClick);
		});
	}
});
